<template>
  <div>
    <div class="title-box">
      <div class="title">情绪档案</div>
      <a-button type="primary" ghost @click="addEventClick">添加事件</a-button>
    </div>
    <div class="card-box">
      <a-row v-if="lineChartList.length" :gutter="10">
        <a-col v-for="(item, index) in lineChartList" :key="index" :span="12">
          <LineChart
            height="220px"
            style="margin-bottom: 20px"
            :title="item.title"
            :fields="item.fields"
            :dataSource="item.dataSource"
            :grid="{
              top: '10%',
              bottom: '25%',
              left: '5.5%',
              right: '5%',
            }"
          />
        </a-col>
      </a-row>
      <EmptyData v-else :styleObj="{ padding: '130px 0' }" :loading="loading" />
      <AddEventModal ref="addEventModal" @refresh="refreshMarked" />
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/echartZyz/components/LineChart'
import AddEventModal from '@/comUi/AddEventModal'
import { getAction } from '@api/manage'
import { handleLineChartData } from '@/utils/util'

export default {
  name: 'MoodArchives',
  components: {
    LineChart,
    AddEventModal,
  },
  props: {
    stuInitInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lineChartList: [],
      grid: { top: '10%', bottom: '25%', left: '8%', right: '8%' },
      loading: false,
    }
  },
  watch: {
    stuInitInfo: {
      handler(data) {
        if (!data?.studentId) return
        this.getLineChartData(data)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getLineChartData(data) {
      this.loading = true
      const res = await getAction('/statistic/childWarnNumTrend', {
        ...data,
        dataType: 2,
      })
      this.loading = false
      if (res.success) {
        // 变化趋势
        const { filedList, lineData } = handleLineChartData(res.result?.moodScoreAndWarnNumTrend)
        // 心情波动指数
        const studentVarianceUndulateTrend = res.result?.studentVarianceUndulateTrend || []
        // const undulateMoodField =
        //   studentVarianceUndulateTrend.length > 0
        //     ? Object.keys(studentVarianceUndulateTrend[0]).filter((key) => key != 'type')
        //     : []

        //学生活跃情况
        const studentActivity = res.result.studentActivityTrend.map((item) => ({
          ...item,
          学生活跃度: item.activity,
        }))
        // 家长关注度
        const parentAttention = res.result.parentAttention
        const mapParentAttention =
          parentAttention.length > 0
            ? parentAttention.map((item) => {
                return {
                  type: item.visit_date,
                  家长关注度: item.parentVisitCnt,
                }
              })
            : []
        const chartList = [
          {
            title: '情绪趋势变化',
            dataSource: lineData,
            fields: filedList,
          },
          {
            title: '心情波动指数趋势',
            dataSource: studentVarianceUndulateTrend,
            fields: ['波动指数'],
          },
          {
            title: '学生活跃情况',
            dataSource: studentActivity,
            fields: ['学生活跃度'],
          },
          {
            title: '家长关注情况',
            dataSource: mapParentAttention,
            fields: ['家长关注度'],
          },
        ]
        this.lineChartList = chartList
        // console.log('线条信息--', this.lineChartList)
      }
    },
    // 添加事件
    addEventClick() {
      this.$refs.addEventModal.show(this.lineChartList[0].dataSource, this.lineChartList[0].fields)
    },
    // 刷新标注
    refreshMarked(record) {
      const studentMood = this.lineChartList[0].dataSource
      const porintIndex = studentMood.findIndex(
        (item) => item[record.filed + 'id'] == record.id && item.type == record.type
      )
      console.log('record--', record)
      console.log('studentMood--', studentMood)
      console.log('porintIndex', porintIndex)
      if (porintIndex != -1) {
        const incident = record.filed + 'incident'
        studentMood[porintIndex][incident] = 1
        console.log('studentMood[porintIndex][incident]', studentMood[porintIndex][incident])
        console.log('studentMood', studentMood)
        this.$set(this.lineChartList[0], 'dataSource', [...studentMood])
        console.log('studentMood数据', this.lineChartList[0].dataSource)
      }
    },
  },
}
</script>
<style scoped lang="less">
.title {
  font-size: 18px;
  font-weight: bold;
}

.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.card-box {
  padding: 20px 15px 0 15px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  min-height: 300px;
}
</style>
